import '../../admin-shared.css'

import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { useNavigate } from 'react-router-dom'

import { PageHeader, Spinner } from '../../../../Components'
import { useCQuery } from '../../../../Services/QueryCache'
import { cap } from '../../../../State'
import { translations } from '../../../../translations'
import { actionsColumnProps, columnProps } from '../../../Prompts/Functions'
import { AdminTableActions } from '../../Components/AdminTableActions'
import { deleteUser } from '../Editor/Functions'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

const AVATAR_COLORS = ['blue', 'green', 'orange', 'pink']

/**
 * Genera le iniziali per l'avatar a partire dallo username.
 * @param {string} username - Nome utente
 * @returns {string} Iniziali (max 2 caratteri)
 */
function getUsernameInitials(username = '') {
  return username
    .split(/[.@]/)
    .slice(0, 2)
    .map((s) => s[0]?.toUpperCase() || '')
    .join('')
}

export function UsersList() {
  const { data: users = [], isSuccess } = useCQuery(['users'])
  const navigate = useNavigate()

  if (!isSuccess) return <Spinner />

  return (
    <>
      <PageHeader
        title={t.userListTitle}
        actions={
          <button
            type="button"
            className="nbtn nbtn--primary"
            onClick={() => navigate('/admin/users/new')}
          >
            <i className="pi pi-plus" style={{ fontSize: 14 }} />
            {t.createNew}
          </button>
        }
      />

      <div className="ncard admin-table-card" style={{ padding: 0 }}>
        <div className="ncard__head">
          <div className="ncard__ico">
            <i className="pi pi-users" style={{ fontSize: 16 }} />
          </div>
          <div>
            <h3 className="ncard__title">{t.userListTitle}</h3>
          </div>
        </div>
        <DataTable
          style={{ width: '100%' }}
          filterDisplay="row"
          sortField="createdAt"
          sortOrder={-1}
          className="TableSignatures ntable"
          value={users}
          emptyMessage={t.noUserFound}
          responsiveLayout="scroll"
          paginator
          rows={10}
        >
          <Column
            field="username"
            {...columnProps('Username')}
            body={(row, { rowIndex }) => (
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <span
                  className={`navatar navatar--${AVATAR_COLORS[rowIndex % AVATAR_COLORS.length]}`}
                >
                  {getUsernameInitials(row.username)}
                </span>
                <span style={{ fontFamily: 'var(--font-mono)', fontSize: 13 }}>{row.username}</span>
              </div>
            )}
          />
          <Column
            field="createdAt"
            {...columnProps(t.creationDate)}
            body={({ createdAt }) => (
              <span className="ntable__meta">{new Date(createdAt).toLocaleDateString()}</span>
            )}
          />
          <Column
            style={{ width: 140, textAlign: 'right' }}
            {...actionsColumnProps}
            body={({ id }) => (
              <AdminTableActions
                id={id}
                editPath="/admin/users/"
                onDelete={deleteUser}
                deleteHeader={t.deleteUserHeader}
                deleteMessage={t.deleteUserMessage}
              />
            )}
          />
        </DataTable>
      </div>
    </>
  )
}
